import * as reducer from './reducers';

import * as mapTypes from './types';
import * as mapOperations from './operations';
import * as mapSelectors from './selectors';
import * as mapActions from './actions';

export { mapTypes, mapOperations, mapSelectors, mapActions };

export default reducer;
